import React, {Component} from "react";
import NewsImage from "../../../images/home.jpg";

class NewsCard extends Component{

    constructor(props){
        super(props);
        this.state = {
            newsCard : 
                {
                    id : "1",
                    date : "6th  December, 2020",
                    time : "03:58AM",
                    name : "LocalTrade",
                    totalRaise : "$28,000",
                    content : "HIncubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only. All projects listed here are part of our incubation program and subjected to additional... HIncubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only. All projects listed here are part of our incubation program and subjected to additional...",
                }
        }
    }

    render(){
        return(
            <div className="news-card sec-bg sec-bg-cont br-10">
                <div className="news-card-img-c">
                    <img src={NewsImage} />
                </div>
                <div className="news-card-content-breadcrumb">
                    <div className="float-content">
                        <h4 className="prim-txt">Total Raise: <span className="sec-txt small-txt">{this.state.newsCard.totalRaise}</span> </h4> 
                    </div>
                    <div className="date-time-ref">
                        <span>{this.state.newsCard.date}</span>
                        <span>{this.state.newsCard.time}</span> 
                    </div>
                    <h2>{this.state.newsCard.name}</h2>
                    <div className="news-card-social">
                        <i className="fab fa-twitter"></i> 
                        <i className="fab fa-facebook"></i> 
                        <i className="fab fa-whatsapp"></i> 
                    </div>
                    <div>
                        <p className="sec-txt small-txt news-card-content">{this.state.newsCard.content}</p>
                    </div>
                    <p className="small-txt prim-txt">Read More <i className="fas fa-angle-down"></i></p>
                </div>
            </div>
        );
    }
}

export default NewsCard;